import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useState, useRef } from 'react';
import H5 from '@base/H5/H5';
import Button from '@base/Button/Button';
import { Spacings } from '@styles/index';
import Share from '@icon/Share';
import Whatsapp from '@icon/Whatsapp';
import BottomSheet from '@comp/BottomSheet/BottomSheet';
import ShareDialog from '@comp/ShareDialog/ShareDialog';
import Dialog from '@comp/Dialog/Dialog';
import socialShare from '@utils/socialShare';
import { getFullDate, formatTime } from '@utils/dates';
import AvatarGroup from '../AvatarGroup';

const getShareText = (contestStartTime, referralCode) => {
  return `Hey! Let’s battle it out on Unacademy Combat, this ${getFullDate(
    contestStartTime
  )} at ${formatTime(
    contestStartTime
  )}. Use my code ‘${referralCode}’ and unlock this exciting Combat. Let’s Crack It!`;
};

const StyledH5 = styled(H5)`
  text-align: center;
`;

const Title = styled(StyledH5)`
  margin-top: ${Spacings.SPACING_3B};
`;

const Desc = styled(StyledH5)`
  margin-bottom: ${Spacings.SPACING_6B};
`;

const Wrapper = styled.div`
  display: grid;
  grid-template: 1fr / 5.67fr 1fr;
  grid-column-gap: ${Spacings.SPACING_2B};
`;

const StyledBtn = styled(Button)`
  border-radius: ${Spacings.SPACING_2B};
`;

const ShareBtn = styled(StyledBtn)`
  background-image: linear-gradient(
    180deg,
    var(--color-i-blue-4) 0%,
    var(--color-i-blue-3) 100%
  );
`;

const YouAreIn = ({ show, onClose, goalUID, goalSlug, selectedCombatInfo }) => {
  const shareUrl = `https://unacademy.com/combat/${goalSlug}/${goalUID}`;
  const upComingContest = selectedCombatInfo || {};
  const contestStartTime = upComingContest.starts_at;
  const referralCode = useSelector(
    ({ auth }) => auth.me?.referralInfo?.code || ''
  );
  const shareText = getShareText(contestStartTime, referralCode);
  const dispatchAction = () => {};
  const shareViaWhatsApp = () => {
    socialShare.handleWhatsappShare({
      url: shareUrl,
      text: shareText
    });
    dispatchAction('WhatsApp');
  };
  const [showShareOptions, setShowShareOptions] = useState(false);
  const wasShareOptionsOpened = useRef(false);

  const openShareOptiopns = () => {
    wasShareOptionsOpened.current = true;
    setShowShareOptions(true);
    dispatchAction('Others');
  };
  const closeShareOptiopns = () => {
    setShowShareOptions(false);
    setTimeout(onClose, 300);
  };
  return (
    <>
      <BottomSheet
        open={show && !wasShareOptionsOpened.current}
        onClose={onClose}
      >
        <AvatarGroup />
        <Title>Awesome, You’re in!</Title>
        <Desc $isLast>Invite friends and challenge them to a combat</Desc>
        <Wrapper>
          <ShareBtn
            grid={5}
            color="green"
            variant="filled"
            label="Invite on WhatsApp"
            icon={<Whatsapp size="20px" color="var(--color-base-1)" />}
            onClick={shareViaWhatsApp}
          />
          <StyledBtn
            grid={1}
            color="green"
            variant="hollow"
            icon={<Share size="20px" />}
            onClick={openShareOptiopns}
          />
        </Wrapper>
      </BottomSheet>
      <Dialog onClose={closeShareOptiopns} dialogState={showShareOptions}>
        <ShareDialog
          data={{
            name: shareText,
            permalink: shareUrl
          }}
          useDataLink
          twitterText={shareText}
        />
      </Dialog>
    </>
  );
};

YouAreIn.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  goalUID: PropTypes.string.isRequired,
  goalSlug: PropTypes.string.isRequired,
  selectedCombatInfo: PropTypes.objectOf(PropTypes.any).isRequired
};

export default YouAreIn;
